import React, { useCallback, useEffect, useState } from 'react'

import {Grid, CircularProgress} from '@mui/material'
import { useSelector } from 'react-redux'

import useStyles from './styles.js'

import Competition from './competition/Competition.js'

import {discipline_all, getActualSeason, season_all} from '../../bdd/bddSTUB.js'
import Select_Dsas from '../../dsasComponents/Select_Dsas.js'
import FilterGroupProvider from '../../dsasComponents/FilterGroupProvider.js'
import { isAdminDSAS } from '../../actions/auth.js'
import { useFetch } from '../../filters/useFetch.js'
import { fetchCompetitions } from '../../api/index.js'
import { reload } from '../../filters/reload.js'
import { FETCH_ALL_COMPETITION } from '../../constants/actionTypes.js'
import Pagination from '../../dsasComponents/pagination/Pagination.js'

const Competitions = ( { setCurrentId }) => {
    const classes = useStyles();

    const [filters, setFilters] = useState({discipline : '', provider : '', season : getActualSeason()})

    const [competitions, loading] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)


    return (
        loading ? <CircularProgress /> : (<>
                <div>
                    {isAdminDSAS() && <FilterGroupProvider
                        classname={classes.customInput}
                        labelId = {"provider_label"}
                        label = {"Groupe"}
                        selectId = {"provider"}
                        name = {"provider"}
                        filters = {filters} 
                        setFilters = {setFilters}
                    />}
                    <Select_Dsas
                                className={classes.selectInput}
                                labelId = {"discipline_label"}
                                label = {"Discipline"}
                                selectId = {"discipline"}
                                name = {"discipline"}
                                value = {filters.discipline}
                                items = {discipline_all}
                                onChange = {(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                                onReset = {(e) => setFilters(state => ({...state, discipline : ''}))}
                    />

                    <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                    />          
                </div>

                <Pagination items={competitions} classes={classes}>
                    {competitions.map(competition => 
                        <Competition competition={competition} setCurrentId={setCurrentId} reload={() => reload(setFilters)}/>
                    )}
                </Pagination></>
        )
        
    )
}

export default Competitions